







































































import { Watch, Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'

@Component
export default class Financial extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, required: false }) disabled: boolean
    @Inject() readonly saveReferral: (referral: Referral) => Promise<void>
    saving: boolean = false

    async onSaveClick(): Promise<void> {
        this.saving = true
        await this.saveReferral(this.referral)
        this.saving = false
    }

    @Watch('referral.orderValue')
    @Watch('referral.leadCommission')
    updateNettoOrderValue(): void {
        if (this.referral.orderValue === null) {
            return null
        }

        if (this.referral.leadCommission === null) {
            this.referral.nettoOrderValue = this.referral.orderValue
        }

        this.referral.nettoOrderValue = Number(this.referral.orderValue) - Number(this.referral.leadCommission)
    }

    get isOrdersEnabled(): boolean {
        return this.$currentCompany.orderSettings
            && this.$currentCompany.orderSettings.enabled
    }
}
